const messagingConstants = {
  GET_CONVERSATIONS: "GET_CONVERSATIONS",
  CLEAR_CONVERSATIONS: "CLEAR_CONVERSATIONS",
  INITIALIZE_CHAT: "INITIALIZE_CHAT",
  LOAD_UP_CHAT_MESSAGES: "LOAD_UP_CHAT_MESSAGES",
  SEND_MESSAGE: "SEND_MESSAGE",
  CLEAR_CHAT: "CLEAR_CHAT",
  GET_CHAT_USER_INFORMATION: "GET_CHAT_USER_INFORMATION",
  UPDATE_PARTICIPANT_IMAGE_URL: "UPDATE_PARTICIPANT_IMAGE_URL",
  CHANGE_IS_LAST_RESULT_FOR_CHAT: "CHANGE_IS_LAST_RESULT_FOR_CHAT",
  LOAD_PREVIOUS_MESSAGES: "LOAD_PREVIOUS_MESSAGES",
  CHANGE_NEW_MESSAGE_ADDED_FLAG: "CHANGE_NEW_MESSAGE_ADDED_FLAG",
  CHANGE_LAST_RESULT_FOR_CONVERSATIONS: "CHANGE_LAST_RESULT_FOR_CONVERSATIONS",
  LOAD_MORE_CONVERSATIONS: "LOAD_MORE_CONVERSATIONS"
};
export default messagingConstants;



// WEBPACK FOOTER //
// ./src/_constants/messagingConstants.js